<h3 class="race-percentage-title bold fund-allocation">Number of students per university</h3>
<section class="chart-container">
  <canvas #canvas id="fundedStudentsChartId"> {{ fundedStudentsChart }} </canvas>
</section>
